/*
 * PRD-037 — Validacion de WhatsApp del portal del partner.
 * El registro normal persiste `telefono_contacto` como '52' + 10 digitos (lada MX sin '+';
 * ver plick-pc-registro). El claim envia ese valor tal cual al proveedor de WhatsApp, asi que
 * el alta del partner debe guardarlo en el mismo formato para que el OTP llegue al dueno.
 */
export const MX_LADA = '52';

export const onlyDigits = (s: string): string => (s || '').replace(/\D/g, '');

// Devuelve los 10 digitos nacionales, quitando la lada de pais si viniera incluida (52/521 + 10).
export const localDigits = (raw: string): string => {
  const d = onlyDigits(raw);
  if (d.length >= 12 && d.startsWith('521')) return d.slice(3, 13);
  if (d.length >= 12 && d.startsWith('52')) return d.slice(2, 12);
  return d.slice(0, 10);
};

export const isValidLocal = (raw: string): boolean => localDigits(raw).length === 10;

// Formato persistido por el backend: telefono_contacto = '52' + 10 digitos.
export const toStoredPhone = (raw: string): string => `${MX_LADA}${localDigits(raw)}`;
